const AccountRouteName = Object.freeze({
  PersonalData: 'account/personal-data',
  Documents: 'account/documents',
  DocumentsUpload: 'account/documents/upload',
  AccountData: 'account/data',
  AccountVerification: 'account/verification',
  ConfirmData: 'account/confirm',
  TaxReports: 'account/tax-report',
  Users: 'account/users',
  UsersConfirmation: 'account/users/confirmation',
  OutgoingPayments: 'payments/outgoing',
  PredefinedPayments: 'payments/predefined',
  PendingPayments: 'payments/pending',
  PendingSign: 'payments/pending/sign',
  Dashboard: 'dashboard',
  MyTransactions: 'my-transactions',
  OpenCurrentAccount: 'open-current-account',
  AccountsLimits: 'limits'
})

const AccountLimitsChangeStatus = Object.freeze({
  AutoApproved: 'AUTO_APPROVED',
  Pending: 'PENDING'
})

const AccountMoneyPurposeAnswerMaxLength = 250
const AccountMoneyOriginAnswerMaxLength = 250

const PendingPaymentPageSize = 500
const PendingPaymentPageNumber = 1

export {
  AccountRouteName,
  AccountLimitsChangeStatus,
  AccountMoneyPurposeAnswerMaxLength,
  AccountMoneyOriginAnswerMaxLength,
  PendingPaymentPageSize,
  PendingPaymentPageNumber
}
